import React, { useState, useEffect, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import { ImSearch } from "react-icons/im";
import { FaRegBell } from "react-icons/fa";
import { HiChevronDown, HiChevronRight } from "react-icons/hi";
import "../../assets/styles/layout/topbar.scss";
import logo from "../../assets/img/leftmenu.png";
import LoginService from "../../services/login";
import GV from "../../services/globalVar";
import { Badge } from "primereact/badge";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import { timer, of } from "rxjs";
import { switchMap, startWith } from "rxjs";
import dashboardService from "../../services/dashboard-service";
import { Dropdown as Primedropdown } from "primereact/dropdown";
import { BiSupport } from "react-icons/bi";
import { Tooltip } from "primereact/tooltip";
import { CgMenuGridO } from "react-icons/cg";
import { Popover } from "antd";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Ticket from "./Ticket";
import { IoMdHelpCircleOutline } from "react-icons/io";
import userlogo from "../../assets/img/SampleUser.png";
import { TieredMenu } from 'primereact/tieredmenu';

export default function TopBar(props) {
  const lgs = new LoginService();
  const ds = new dashboardService();
  const [activeMenu, setActiveMenu] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const [visibleRight, setVisibleRight] = useState(false);
  const [timeAgo, setTimeAgo] = useState("");
  const [nitification, setNotification] = useState([]);
  const [isNotification, setIsNotification] = useState(false);
  const [deletedNotifications, setDeletedNotifications] = useState([]);
  const [otherMenus, setOtherMenus] = useState([]);
  const [modelProduct, setModelProduct] = useState([]);
  const [showProductImg, setShowProductImg] = useState([]);
  const [productUrlPage, setProductUrlPage] = useState({ app: "", title: "" });
  const [visible, setVisible] = useState(false);
  const [isProcess, setIsProcess] = useState(false);
  const [image, setImage] = useState();
  const [selectedProds, setSelectedProds] = useState(true);
  const [isTicket, setIsTicket] = useState(false);
  const [billingProfile, setBillingProfile] = useState([]);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [tenantList, setTenantList] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(null);
const tenantMenuRef = useRef(null);
  const features = [
    { id: "feature1", label: "Feature 1" },
    { id: "feature2", label: "Feature 2" },
    { id: "feature3", label: "Feature 3" },
    { id: "feature4", label: "Feature 4" },
  ];

  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    institute: "",
    email: "",
    phoneNumber: "",
  });

  const schema = yup.object().shape({
    name: yup.string().required("This field is required"),
    designation: yup.string().required("This field is required"),
    institute: yup.string().required("This field is required"),
    email: yup
      .string()
      .email("Invalid email")
      .required("This field is required"),
    phoneNumber: yup
      .string()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
      .required("This field is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const toast = useRef(null);
  const handleArrowClick = () => {
    let url = "";
    if (productUrlPage.title === "Subscribed Products") {
      url = productUrlPage.app.prodURL;
    } else if (
      productUrlPage.title === "Featured Apps" ||
      productUrlPage.title === "Other Available Apps"
    ) {
      url = productUrlPage.app.marketingURL;
    }
    if (url) {
      window.open(url, "_blank");
    }
  };

const tenantMenuItems = tenantList.map((tenant) => ({
  label: tenant.tenantName,
  icon: tenant.tenantID === selectedTenant?.tenantID
    ? "pi pi-check-circle"
    : "pi pi-building",
  style:
    tenant.tenantID === selectedTenant?.tenantID
      ? {
          backgroundColor: "#e7f1ff",     
          color: "#0d6efd",  
          fontWeight: "bold",
          borderRadius: "6px",
        }
      : {},
  command: () => handleTenantSwitch(tenant),
}));


const handleTenantSwitch = (tenant) => {
  const currentStorage = JSON.parse(localStorage.getItem("userDet"));
  const currentTenantID = currentStorage?.appUser?.tenantID;

  // If selecting same tenant, do nothing
  if (currentTenantID === tenant.tenantID) return;

  // Update state
  setSelectedTenant(tenant);

  // Update localStorage
  const updated = {
    ...currentStorage,
    appUser: {
      ...currentStorage.appUser,
      tenantID: tenant.tenantID,
      tenantName: tenant.tenantName,
      tenantCode: tenant.tenantCode,
      tenantKey: tenant.tenantKey,
      tenantStatus: tenant.tenantStatus,
      tenantType: tenant.tenantType,
      timeZoneID: tenant.timeZoneID,
    },
    tenantDetail: {
      ...currentStorage.tenantDetail,
      tenantID: tenant.tenantID,
      tenantName: tenant.tenantName,
      logo: tenant.logo,
      administratorEmail: tenant.administratorEmail,
      administratorName: tenant.administratorName,
    },
    tenantConfig: {
      countryCode: tenant.tenantConfig.countryCode,
      countryID: tenant.tenantConfig.countryID,
      countryName: tenant.tenantConfig.countryName,
      createdBy: tenant.tenantConfig.createdBy,
      createdOn: tenant.tenantConfig.createdOn,
      currency: tenant.tenantConfig.currency,
      currencyCode: tenant.tenantConfig.currencyCode,
      currencyID: tenant.tenantConfig.currencyID,
      currencyName: tenant.tenantConfig.currencyName,
      dateFormat: tenant.tenantConfig.dateFormat,
      endMonth: tenant.tenantConfig.endMonth,
      endMonthName: tenant.tenantConfig.endMonthName,
      isConfigCompleted: tenant.tenantConfig.isConfigCompleted,
      isFinancialYear: tenant.tenantConfig.isFinancialYear,
      journalType: tenant.tenantConfig.journalType,
      pettyCashCloseType: tenant.tenantConfig.pettyCashCloseType,
      startMonth: tenant.tenantConfig.startMonth,
      startMonthName: tenant.tenantConfig.startMonthName,
      tenantConfigID: tenant.tenantConfig.tenantConfigID,
      tenantID: tenant.tenantConfig.tenantID,
      timeDifference: tenant.tenantConfig.timeDifference,
      timeZoneCode: tenant.tenantConfig.timeZoneCode,
      timeZoneID: tenant.tenantConfig.timeZoneID,
      timeZoneName: tenant.tenantConfig.timeZoneName,
      yearType: tenant.tenantConfig.yearType,
    },
  };

  localStorage.setItem("userDet", JSON.stringify(updated));
  window.location.reload();
};



useEffect(() => {
  const userDet = JSON.parse(localStorage.getItem("userDet"));

  if (tenantList.length > 0 && !selectedTenant) {
    const matchedTenant = tenantList.find(
      (t) => t.tenantID === userDet?.appUser?.tenantID
    );

    setSelectedTenant(matchedTenant || tenantList[0]);
  }
}, [tenantList]);




  const renderMenuSection = (title, apps) => {
    let backgroundColor;
    let bgr;
    switch (title) {
      case "Subscribed Products":
        backgroundColor = "rgb(206 215 196)";
        bgr = "rgb(230 239 220)";
        break;
      case "Featured Apps":
        backgroundColor = "rgb(231 223 201)";
        bgr = "rgb(253 246 228)";
        break;
      case "Other Available Apps":
        backgroundColor = "rgb(181 201 217)";
        bgr = "rgb(218 232 243)";
        break;
      default:
        backgroundColor = "transparent";
    }

    return (
      <div>
        <h4
          className=""
          style={{
            margin: "10px 0",
            fontSize: "14px",
            color: "black",
            border: `1px solid ${backgroundColor}`,
            borderLeft: `10px solid ${backgroundColor}`,
            backgroundColor: bgr,
          }}
        >
          <span
            className="p-2 "
            style={{ borderRadius: "4px 4px 0 0", display: "inline-block" }}
          >
            {title}
          </span>
        </h4>
        <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
          {apps?.map((app, index) => {
            const shouldHideArrow =
              GV.userDet.appUser.productID === app.kProductID;
            return (
              <div
                key={index}
                className="col-md-4 px-3 d-flex justify-content-between align-items-center "
              >
                <div
                  style={{
                    textAlign: "start",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                  onClick={() => productDetails(app, title)}
                >
                  <img
                    src={`data:image/jpeg;base64,${app.productLogo}`}
                    alt={app.prodName}
                    style={{
                      width: "50%",
                      borderRadius: "5px",
                      marginBottom: "5px",
                    }}
                  />
                  <span style={{ fontSize: "12px", color: "gray" }}>
                    <strong className="fst-italic ">
                      {app.detailedDescription}
                    </strong>
                  </span>
                  <br />
                </div>
                {!shouldHideArrow && (
                  <i
                    className="pi pi-arrow-right"
                    onClick={() => {
                      productDetails(app, title);
                    }}
                    style={{ cursor: "pointer", color: "#8CC340" }}
                  ></i>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const GetMasBillingProfileModel = (item) => {
    setIsProcess(true);
    ds.GetMasBillingProfileModel(item)
      .then((res) => {
        setIsProcess(false);
        setBillingProfile(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const GetAppUser = () => {
    setIsProcess(true); // Start loading

    ds.GetAppUser(
      GV.userDet.tenantDetail.tenantID,
      GV.userDet.appUser.appuserID
    )
      .then((res) => {
        const profileImageID = res?.data?.data?.profileImageID;

        if (profileImageID) {
          const datas = {
            DocIDs: profileImageID.toString(),
            DocCategory: "ProfilePicture",
          };

          ds.DownloadDocs(datas)
            .then((res) => {
              const url = res?.data?.data?.[0]?.documentURL;
              if (url) {
                setImage(url); // Set loaded image
              }
              setIsProcess(false); // End loading
            })
            .catch(() => {
              setIsProcess(false);
            });
        } else {
          setIsProcess(false);
        }
      })
      .catch(() => {
        setIsProcess(false);
      });
  };
  const [imgSrc, setImgSrc] = useState(userlogo); // default to fallback

  useEffect(() => {
    if (image) setImgSrc(image); // update when actual image available
  }, [image]);

  const tenantSwitch = () => {
    lgs
      .TenantSwitch(GV.userDet.appUser.appuserID)
      .then((res) => {
        if (res.data.data.length > 1) {
          setTenantList(res.data.data);
        } else {
        }
      })
      .catch((err) => {
        console.error("Error fetching tenant switch data:", err);
        setIsTicket(false);
      });
  };

  const GetFeatureProducts = () => {
    ds.GetFeatureProducts(30616)
      .then((res) => {
        setOtherMenus(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const popoverContent = (
    <div>
      {renderMenuSection("Subscribed Products", otherMenus?.objsub)}
      {otherMenus?.objfeature &&
        otherMenus?.objfeature.length > 0 &&
        renderMenuSection("Featured Apps", otherMenus?.objfeature)}
      {otherMenus?.objothers &&
        otherMenus?.objothers.length > 0 &&
        renderMenuSection("Other Available Apps", otherMenus?.objothers)}
    </div>
  );

  const items = [
    { id: 1, label: "All", value: "all" },
    { id: 2, label: "Read", value: "read" },
    { id: 3, label: "Unread", value: "unread" },
  ];
  const [notificationStatus, setNotificationStatus] = useState(items[0].value);

  const notifyDataRef = useRef(nitification.data);
  const callbackMenu = (val) => {
    props.data.menuCallback(val);
  };
  const callbackMenu1 = (val) => {
    props.data.menuCallback1(val);
  };

  const toggleMenu = () => {
    setActiveMenu(!activeMenu);
    callbackMenu(!activeMenu);
  };
  const toggleSideMenu = () => {
    setShowMenu(!showMenu);
    setActiveMenu(!activeMenu);
    callbackMenu1(!showMenu, !activeMenu);
  };
  const refreshTok = () => {
    const data = {
      RefreshToken: localStorage.getItem("lv"),
      AppUserID: GV.userDet.appUser.appuserID,
    };
    lgs.RefreshToken(data).then((res) => {
      localStorage.setItem("token", res.data.data.accessToken);
      window.location.reload();
    });
  };

  const handleNotificationClick = (
    routeLink,
    date,
    keyPath,
    selectedKeys,
    items
  ) => {
    setVisibleRight(false);
    let startDate = date.split("to")[0];
    let endDate = date.split("to")[1];
    navigate(routeLink, {
      state: { startDate, endDate, keyPath, selectedKeys },
    });
    handleDeleteNotification(items);
    GetUserNotification(notificationStatus);
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    navigate("/ticket");
  };

  const handleDeleteNotification = (a) => {
    ds.UpdateReadNotify(a.tenantID, a.userID, a.notifyID).then((res) => {
      if (res.data.message === "Notification Checked") {
        setDeletedNotifications((prev) => [...prev, a.notifyID]);
        setTimeout(() => {
          setNotification((prevNotification) => {
            const updatedData = Array.isArray(prevNotification.data)
              ? prevNotification.data.filter(
                  (item) => item.notifyID !== a.notifyID
                )
              : [];
            return { ...prevNotification, data: updatedData };
          });
          setDeletedNotifications((prev) =>
            prev.filter((id) => id !== a.notifyID)
          );
        }, 500);
      }
    });
  };

  const readAll = () => {
    ds.UpdateReadNotify(
      GV.userDet.tenantDetail.tenantID,
      GV.userDet.appUser.appuserID,
      0
    ).then((res) => {});
  };

  const handleStatusChange = (status) => {
    setNotificationStatus(status.value);
    GetUserNotification(status);
  };

  const GetUserNotification = (status) => {
    const data = {
      TenantID: GV.userDet.tenantDetail.tenantID,
      UserID: GV.userDet.appUser.appuserID,
      View: status.value,
    };
    ds.GetUserNotification(data).then((res) => {
      setNotification(res.data);
      if (res.data) {
        notifyDataRef.current = res.data.data;
        let isCheck = res.data.data.some((b) => b.isRead);
        setIsNotification(isCheck);
        const updateTimeAgo = () => {
          const newTimeAgo = notifyDataRef.current.map((a) => {
            if (a.deliveredOn) {
              const deliveryDateObj = moment.utc(a.deliveredOn);
              return deliveryDateObj.fromNow();
            }
            return null;
          });

          if (JSON.stringify(newTimeAgo) !== JSON.stringify(timeAgo)) {
            setTimeAgo(newTimeAgo);
          }
        };

        updateTimeAgo();

        const subscription = timer(0, 60000)
          .pipe(
            startWith(0),
            switchMap(() => {
              return of(notifyDataRef.current);
            })
          )
          .subscribe(() => {
            updateTimeAgo();
          });

        return () => {
          subscription.unsubscribe();
        };
      }
    });
  };

  const GetMarketingImage = (item) => {
    setShowProductImg("");
    setIsProcess(true);
    ds.GetMarketingImage(item.kProductID).then((res) => {
      setIsProcess(false);
      setShowProductImg(res.data.data.documentURL);
      GetMasBillingProfileModel(item.kProductID);
    });
  };

  const productDetails = (product, title) => {
    setVisible(true);
    setShowForm(false);
    if (product.kProductID === 6810) {
      setSelectedProds(false);
    } else {
      setSelectedProds(true);
    }
    setProductUrlPage({ app: product, title: title });
    setModelProduct(product);
    GetMarketingImage(product);
  };

  const getProductBackgroundColor = (prodName) => {
    const colors = {
      "Ko-Hamsa": "rgb(213 199 199 / 5%)",
      "Ko-Kadamba": "#f3f8f22b",
      "Ko-Garuda": "rgb(245 215 149 / 3%)",
      "Ko-Pitta": "#fbf5ff2e",
      "Ko-Dodos": "#ebf9ff26",
      "Ko-Shuka": "rgb(255 155 179 / 4%)",
      "Ko-Lims": "#e9f3f938",
      "Ko-Patient Portal": "#eff2ff36",
      USHI: "#22c7b703",
    };
    return colors[prodName] || "#ffffff";
  };

  const selectedCheckBox = (addOn) => {
    setSelectedAddOns((prev) =>
      prev.some((item) => item.masBillingID === addOn.masBillingID)
        ? prev.filter((item) => item.masBillingID !== addOn.masBillingID)
        : [...prev, addOn]
    );
  };

  useEffect(() => {
    GetUserNotification(notificationStatus);
    GetFeatureProducts();
    GetAppUser();
    tenantSwitch();
  }, []);

  return (
    <div className="wrapper topbar">
      <Toast ref={toast} />
      <ConfirmPopup />
      <nav className="navbar navbar-expand-lg  p-0">
        <div
          className="container-fluid bx-shadow1 "
          style={{ height: "67px", zIndex: "1000" }}
        >
          <div className="me-5">
            {GV.userDet.tenantDetail?.logo != "" &&
            GV.userDet.tenantDetail?.logo != null ? (
              <img
                src={GV.userDet?.tenantDetail?.logo}
                alt="Company Logo"
                style={{ width: "auto", height: "50px" }}
              />
            ) : (
              <img src={logo} alt="Profile" style={{ width: "82%" }} />
            )}
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleSideMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
              {GV.userDet.tenantConfig.isConfigCompleted === true ? (
                <li
                className="nav-item menu-icon " 
                style={{ lineHeight: "0" }}
                ></li>
              ) : (
                ""
              )}
              <div className="m-0" style={{fontFamily:"Trade Gothic Next SR Pro Bd Cm", color:"#1E6444", fontSize:"20px"}}>{GV.userDet.appUser.tenantName}</div>
              <li className="nav-item ms-5 mt-2 pt-1 ">
                <div className="input-group search-group mb-3 rounded ">
                  <input
                    style={{ display: "none" }}
                    type="text"
                    className="form-control py-2"
                    placeholder="Search Here"
                    aria-label="search"
                    aria-describedby="basic-addon2"
                  />
                  <span
                    style={{ display: "none" }}
                    className="input-group-text"
                    id="basic-addon2"
                  >
                    <ImSearch />
                  </span>
                </div>
              </li>
            </ul>
            <span className="me-3">
              <Tooltip target=".help" content="help" position="top" />
              <Tooltip target=".support" content="support" position="top" />
              <Tooltip
                target=".Notifications"
                content="Notifications"
                position="top"
              />
              <button className="bg-transparent text-muted help">
                <IoMdHelpCircleOutline size="25" />
              </button>
              <button
                className="bg-transparent text-muted mx-2 support"
                onClick={handleRedirect}
              >
                <BiSupport size="22" />
              </button>
              {isTicket && <Ticket />}
              <button
                className="bg-transparent text-muted Notifications"
                style={{ position: "relative" }}
              >
                <FaRegBell size="22" onClick={() => setVisibleRight(true)} />
                {!isNotification && (
                  <Badge
                    severity="danger"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "-5px",
                      fontSize: "10px",
                    }}
                  ></Badge>
                )}
              </button>

              <Popover
                content={popoverContent}
                title=""
                trigger="click"
                getPopupContainer={() => document.body}
                className="test"
                open={open}
                onOpenChange={handleOpenChange}
                overlayStyle={{ width: "950px" }}
              >
                <CgMenuGridO
                  className="ms-3 text-muted"
                  size={25}
                  style={{ cursor: "pointer" }}
                />
              </Popover>
              <div className="ps-2">{contextHolder}</div>
            </span>

      <div className="dropdown user-dropdown text-center" style={{ marginBottom: "10px"}}>
   <button style={{paddingBottom:"0px"}}
    className="btn dropdown-toggle"
    type="button"
    id="dropdownMenuButton1"
    data-toggle="dropdown"
    aria-expanded="false"
  >
    <img
      src={imgSrc}
      onError={() => setImgSrc(userlogo)}
      className="rounded-circle mx-2"
      width="36"
      height="36"
      alt="User avatar"
    />
    <span className="fw-medium text-dark">{ GV.userDet.appUser.userName}</span>
    <HiChevronDown color="#6c757d" size={20} />
  </button>

  <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2 p-2 text-sm" aria-labelledby="dropdownMenuButton1" style={{ minWidth: "197px", borderRadius: "10px", margin: "-63px" }}>
    
    <li
      className="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 rounded"
      onClick={(e) => {
        e.stopPropagation();
        tenantMenuRef.current.toggle(e);
      }}
      style={{ cursor: "pointer", transition: "background 0.2s" }}
    >
      <span>
        <i className="pi pi-sitemap me-2 text-primary"></i> Switch Tenant
      </span>
      <HiChevronRight size={16} color="#6c757d" />
    </li>

    <TieredMenu
      model={tenantMenuItems}
      popup
      ref={tenantMenuRef}
      appendTo={document.body}
    />

    <li>
      <a className="dropdown-item py-2 px-3 rounded d-flex align-items-center" href="/profile">
        <i className="pi pi-user text-secondary me-2" style={{ fontSize: "1rem" }}></i>
        <span>Profile</span>
      </a>
    </li>

    <li>
      <a className="dropdown-item py-2 px-3 rounded d-flex align-items-center" href="/organization-profile">
        <i className="pi pi-cog text-secondary me-2" style={{ fontSize: "1rem" }}></i>
        <span>Settings</span>
      </a>
    </li>

    <li>
      <a
        className="dropdown-item py-2 px-3 rounded d-flex align-items-center text-danger"
        onClick={() => {
          localStorage.clear();
        }}
        href="/"
      >
        <i className="pi pi-sign-out text-danger me-2" style={{ fontSize: "1rem" }}></i>
        <span>Logout</span>
      </a>
    </li>
  </ul>
             {/* <br /> <small className="m-0">({GV.userDet.appUser.tenantName})</small> */}
</div>


          </div>

          <Dialog
            header="Product Details"
            visible={visible}
            style={{ width: "70vw" }}
            onHide={() => {
              setVisible(false);
              setBillingProfile([]);
              setSelectedAddOns([]);
            }}
          >
            <BlockUI blocked={isProcess}>
              <div
                className="row"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                <div className="col-md-12 px-3 d-flex justify-content-between  ">
                  <div
                    className="col-md-3 py-2"
                    style={{
                      textAlign: "start",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${modelProduct.productLogo}`}
                      alt={modelProduct.prodName}
                      style={{ width: "50%", borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div className="col-md">
                  <strong>{modelProduct.detailedDescription}</strong>
                </div>
                <br />
                <hr />

                <div className="row mx-auto">
                  <div className="col-md-12">
                    <div className="row d-flex">
                      <div className="col-md-8 d-flex">
                        <div
                          className="card flex-grow-1"
                          style={{
                            height: "570px",
                            border: `${showProductImg && "none"}`,
                          }}
                        >
                          {showProductImg ? (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  height: "100%",
                                }}
                              >
                                <img
                                  className="border border-1"
                                  src={`data:image/jpeg;base64,${showProductImg}`}
                                  alt="Product"
                                  style={{
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              {selectedProds && (
                                <div className="text-center">
                                  <button
                                    className="btn btn-primary my-2"
                                    onClick={handleArrowClick}
                                  >
                                    {" "}
                                    See More...{" "}
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <p
                              style={{
                                color: "white",
                                textAlign: "center",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            >
                              No image
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 ps-4 d-flex">
                        <div
                          className="card flex-grow-1 d-flex flex-column"
                          style={{
                            minHeight: "570px",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e0e0e0",
                            borderRadius: "10px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <div
                            className="card-body p-0 d-flex flex-column flex-grow-1"
                            style={{
                              backgroundColor: getProductBackgroundColor(
                                modelProduct?.prodName
                              ),
                            }}
                          >
                            {!showForm ? (
                              <>
                                {/* Core Features */}
                                <div className="m-3">
                                  <strong
                                    className="form-label"
                                    style={{
                                      fontSize: "1.2rem",
                                      color: "#333",
                                    }}
                                  >
                                    Core Features
                                  </strong>
                                  <ul className="list-unstyled mt-2">
                                    {billingProfile?.objcore?.length ? (
                                      billingProfile.objcore.map((feature) => (
                                        <li
                                          key={feature?.masBillingID}
                                          className="ms-2 mb-2"
                                        >
                                          <span style={{ color: "#555" }}>
                                            ✔️
                                          </span>{" "}
                                          <span style={{ color: "#333" }}>
                                            {feature?.serviceName}
                                          </span>
                                        </li>
                                      ))
                                    ) : (
                                      <li
                                        className="ms-2 mb-2"
                                        style={{ color: "#888" }}
                                      >
                                        No data
                                      </li>
                                    )}
                                  </ul>
                                </div>

                                <div className="m-3">
                                  <strong
                                    className="form-label"
                                    style={{
                                      fontSize: "1.2rem",
                                      color: "#333",
                                    }}
                                  >
                                    {" "}
                                    Add-ons Features{" "}
                                  </strong>
                                  {billingProfile?.objadd?.length ? (
                                    billingProfile.objadd.map((addOn) => (
                                      <div
                                        className="ms-2 mt-2"
                                        key={addOn?.masBillingID}
                                      >
                                        <div className="form-check">
                                          <input
                                            type="checkbox"
                                            id={`addon-${addOn?.masBillingID}`}
                                            className="form-check-input"
                                            checked={selectedAddOns.some(
                                              (item) =>
                                                item.masBillingID ===
                                                addOn.masBillingID
                                            )}
                                            onChange={() =>
                                              selectedCheckBox(addOn)
                                            }
                                            style={{ cursor: "pointer" }}
                                          />
                                          <label
                                            htmlFor={`addon-${addOn?.masBillingID}`}
                                            className="form-check-label ms-2"
                                            style={{ color: "#555" }}
                                          >
                                            {addOn.serviceName}
                                          </label>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div
                                      className="ms-2 mt-2"
                                      style={{ color: "#888" }}
                                    >
                                      No data
                                    </div>
                                  )}
                                </div>
                              </>
                            ) : (
                              <div className="m-3">
                                <h4 className="mb-3">Selected Features</h4>
                                <strong
                                  className="form-label"
                                  style={{ fontSize: "1.2rem", color: "#333" }}
                                >
                                  Core Features
                                </strong>
                                <ul className="list-unstyled mt-2">
                                  {billingProfile?.objcore?.length ? (
                                    billingProfile.objcore.map((feature) => (
                                      <li
                                        key={feature?.masBillingID}
                                        className="ms-2 mb-2"
                                      >
                                        <span style={{ color: "#555" }}>
                                          ✔️
                                        </span>{" "}
                                        <span style={{ color: "#333" }}>
                                          {feature?.serviceName}
                                        </span>
                                      </li>
                                    ))
                                  ) : (
                                    <li
                                      className="ms-2 mb-2"
                                      style={{ color: "#888" }}
                                    >
                                      No data
                                    </li>
                                  )}
                                </ul>

                                <strong
                                  className="form-label"
                                  style={{ fontSize: "1.2rem", color: "#333" }}
                                >
                                  Selected Add-ons
                                </strong>
                                <ul className="list-unstyled mt-2">
                                  {selectedAddOns.length ? (
                                    selectedAddOns.map((addOn) => (
                                      <li
                                        key={addOn.masBillingID}
                                        className="ms-2 mb-2"
                                      >
                                        <span style={{ color: "#555" }}>
                                          ✔️
                                        </span>{" "}
                                        <span style={{ color: "#333" }}>
                                          {addOn.serviceName}
                                        </span>
                                      </li>
                                    ))
                                  ) : (
                                    <li
                                      className="ms-2 mb-2"
                                      style={{ color: "#888" }}
                                    >
                                      No add-ons selected
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}

                            <div className="m-3 mt-auto">
                              {!showForm ? (
                                <>
                                  {selectedProds && (
                                    <button
                                      className="btn btn-primary w-100"
                                      onClick={() => setShowForm(true)}
                                    >
                                      Subscribe
                                    </button>
                                  )}
                                </>
                              ) : (
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-danger w-50"
                                    type="button"
                                    onClick={() => setShowForm(false)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-primary w-50"
                                    type="submit"
                                  >
                                    Confirm
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isProcess && (
                <ProgressSpinner
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                  strokeWidth="2"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              )}
            </BlockUI>
          </Dialog>

          <Sidebar
            visible={visibleRight}
            position="right"
            onHide={() => setVisibleRight(false)}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="my-2">Notification</h4>
              <div className=" kk-table-header kk-header-sec cc-font-size-14">
                <div className="col">
                  <Primedropdown
                    value={notificationStatus}
                    onChange={(e) => {
                      handleStatusChange(e);
                    }}
                    options={items}
                    optionLabel="label"
                    placeholder="Notification filter"
                    className="col-auto text-start me-3 my-auto"
                  />
                </div>
              </div>
            </div>
            <></>
            {nitification.data?.map((a, i) => (
              <div
                key={a.notifyID}
                className={`mb-2 ${!a.isRead ? "" : "bg-light"}`}
                style={{
                  opacity: deletedNotifications.includes(a.notifyID) ? 0 : 1,
                  transition: "opacity 0.5s ease-out",
                  backgroundColor: !a.isRead ? "#E3F2FD" : "",
                }}
              >
                <div className="d-flex justify-content-between">
                  <div className="mx-2">
                    <strong
                      className="me-2"
                      style={{
                        fontWeight: a.isRead ? "normal" : "bold",
                        color: a.isRead ? "gray" : "black",
                      }}
                    >
                      {a.subject}
                    </strong>
                    <Badge
                      style={{
                        backgroundColor: !a.isRead ? "#6366F1" : "darkgray",
                      }}
                    />{" "}
                    {timeAgo[i]}
                  </div>
                  <button
                    className="bg-transparent text-end fst-italic m-1 px-2"
                    onClick={() => handleDeleteNotification(a)}
                  >
                    <i
                      className="pi pi-times"
                      style={{ fontSize: "0.9rem" }}
                    ></i>
                  </button>
                </div>

                <p
                  className="m-0 ps-2 pb-2"
                  style={{
                    cursor: !a.isRead ? "pointer" : "default",
                    color: !a.isRead ? "gray" : "black",
                  }}
                  onClick={() =>
                    !a.isRead &&
                    handleNotificationClick(
                      a.routeLink,
                      a.input,
                      a.keyPath,
                      a.selectedPath,
                      a
                    )
                  }
                >
                  {a.content}
                </p>
              </div>
            ))}
            <div className="d-flex justify-content-end">
              <button className="btn btn-primary" onClick={() => readAll()}>
                Read All
              </button>
              <button
                className="btn btn-danger mx-2"
                onClick={() => setVisibleRight(false)}
              >
                {" "}
                Close
              </button>
            </div>
          </Sidebar>
        </div>
      </nav>
    </div>
  );
}
